import React from 'react';
// import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

// import * as routes from '../settings/_routesSettings';

import HeaderMenu from '../containers/HeaderMenu';

const CheckoutPlansRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} component={(props) => (
    <div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <HeaderMenu isSuccinct />
      <Component {...props} />
    </div>
  )}
  />
);

export default (CheckoutPlansRoute);

// const CheckoutPlansRoute = ({ isAuth, component: Component, ...rest }) => (
//   <Route {...rest} component={(props) => (
//     isAuth ? (
//       <div style={{ backgroundColor: '#f5f5f5' }}>
//         <HeaderMenu isSuccinct/>
//         <Component {...props} />
//       </div>
//     ) : (
//       <Redirect to={routes.HOME} />
//     )
//   )}
//   />
// );

// const mapStateToProps = (state) => ({ isAuth: state.auth.isAuth });

// export default connect(mapStateToProps)(CheckoutPlansRoute);